export default __webpack_public_path__ + "static/media/login.fc87c94b.jpg";